const gif = `<svg title="gif icon" aria-hidden="true" id="icon_gif" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0h96v96H0V0z" fill="none"/></svg>`;
export {
  gif
};
//# sourceMappingURL=media.js.map
